import React from 'react';
import { Typography } from '@material-ui/core';

import { PropsType } from 'components/Typography/types';

import breakpoints from 'utils/breakpoints';
import styled from 'styled-components';

const StyledTypography = styled(({ color, weight, ...otherProps }) => (
  <Typography {...otherProps} />
))`
  font-weight: ${(props) => props.weight} !important;
  color: ${(props) => props.color} !important;
  @media (max-width: ${breakpoints.xs}) {
    font-size: 15px !important;
  }
`;

const SmallSectionHeader = (props: PropsType) => {
  return (
    <StyledTypography variant="h4" {...props}>
      {props.children}
    </StyledTypography>
  );
};

export default SmallSectionHeader;
